import styled from 'styled-components'
import BaseButton from 'components/Button'

import { colors } from 'styles/colors'

export const FormContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    border: 1px solid #f0f0f0;
    border-radius: 16px;
`

export const FormHeader = styled.div`
    padding: 20px;
    background-color: ${({ $gradientColor }) => $gradientColor};
    border-bottom: 1px solid #f0f0f0;
    border-radius: 16px 16px 0 0;
    width: 100%;
    display: flex;

    > * + * {
        margin-left: 10px;
    }

    @media (max-width: 425px) {
        padding: 15px;
    }
`

export const DivImage = styled.div`
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: flex-start;

    img {
        display: block;
        width: 50px;
    }
`

export const ProductName = styled.span`
    font-size: 20px;
    font-weight: 300;
    line-height: 150%;

    text-transform: uppercase;

    color: white;
`

export const FormTitle = styled.h3`
    font-weight: 600;
    font-size: 16px;
    line-height: 21px;
    color: white;
`

export const Label = styled.span`
    font-weight: 400;
    font-size: 12px;
    line-height: 13px;

    text-transform: none;
    text-align: center;

    color: ${({ $color }) => $color ?? colors.black};
`

export const FormFields = styled.div`
    display: flex;
    width: 100%;

    .card-quantity {
        flex: 0.9;
    }

    .card-value {
        flex: 1.1;
    }

    div + div {
        margin-left: 10px;
    }
`

export const FormColumn = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 5px;
    }
`

export const FormRow = styled.div`
    display: flex;

    align-items: center;

    .card-quantity {
        flex: 0.9;
    }

    .card-value {
        flex: 1;
    }

    > * + * {
        margin-left: 10px;
    }
`

export const FormBody = styled.div`
    height: 100%;
    width: 100%;
    padding: 20px;

    display: flex;
    flex-direction: column;

    justify-content: space-between;

    > * + * {
        margin-top: 5px;
    }

    @media (max-width: 425px) {
        padding: 15px;
    }
`

export const ProductInfo = styled.div`
    display: flex;
    align-self: flex-start;
`

export const ErrorMessageContainer = styled.div`
    text-align: right;
`

export const Button = styled(BaseButton)`
    margin: 10px 0 0 !important;
    padding: 15px;
`

export const ButtonClose = styled(BaseButton)`
    margin: 10px 0 0 !important;
    color: #666;
    background-color: #eee;
    padding: 8px 25px;
    font-size: 12px;
    font-weight: 600;

    &:hover {
        box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);
    }

    &:active {
        background-color: darken(#eee, 2%);
    }
`

export const Action = styled.div`
    display: flex;
    justify-content: center;
`

export const Wrap = styled.div`
    margin-top: 10px;

    & > div {
        margin-top: 20px;
    }
`
